<template>
    <div class='s_flex_bian m-b-20'>
      <div class="card ">
        <div class="card_main">
          <div class="card_items s_bf4f">
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400"> {{detail.deliveryCount}} </h6>
              <span>待发货订单</span>
            </div>
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.refundCount}}</h6>
              <span>待处理收货订单</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card ">
        <div class="card_main">
          <div class="card_items s_bf4f">
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.settleAll || 0}}</h6>
              <span>结算订单数</span>
            </div>
            <div class='card_item  s_wsn'>
              <h6 style="font-weight:400">{{detail.completeAll || 0}}</h6>
              <span>已完成订单数</span>
            </div>
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.refundAll || 0}}</h6>
              <span>退款订单数</span>
            </div>
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.cancelAll || 0}}</h6>
              <span>取消订单数</span>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class=' m-b-60'>
      <div class="card ">
        <div class="card_main">
          <div class="card_items s_bf4f">
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400"> {{detail.totalData.order_all_count || 0}}</h6>
              <span>总订单数</span>
            </div>
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.totalData.order_price_all_total || 0}}</h6>
              <span>总成交额</span>
            </div>
             <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{detail.totalData.order_refund_price_total || 0}}</h6>
              <span>成功退款金额</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='initData' layout='inline'>
      <a-form-item>
        <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.day_type">
          <a-radio-button :value="1">7天</a-radio-button>
          <a-radio-button :value="2">30天</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="">
        <a-range-picker  v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <!-- <a-form-item label="订单类型">
        <a-select  style="width: 120px" v-model:value="search.order_source">
          <a-select-option value="">
            全部
          </a-select-option>
          <a-select-option :value="1">
            云店订单
          </a-select-option>
          <a-select-option :value="2">
            活动订单
          </a-select-option>
          <a-select-option :value="3">
            奖品订单
          </a-select-option>
          <a-select-option :value="6">
            夺宝订单
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item>
        <a-button type="primary" @click='initData'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered class='m-b-20' :data-source="detail.data" :columns="columns" :loading='loading' rowKey="order_type_texts">
    </a-table>
</template>
<script>
import { ref } from "vue";
import { getOrderGeneral } from "@/api/order";
export default {
  name: "orderType",
  setup() {
    const dataSource = ref([]);
    const columns = [
      {
        title: "订单类型",
        dataIndex: "order_type_texts",
      },
      {
        title: "下单数",
        dataIndex: "order_count",
      },
      {
        title: "成交订单数",
        dataIndex: "order_finish_count",
      },
      {
        title: "成交人数",
        dataIndex: "user_finish_count",
      },
      {
        title: "成交金额",
        dataIndex: "order_price_finish_total",
      },
      {
        title: "成交订单占比",
        dataIndex: "percentage",
      },
    ];
    const time = ref([]);
    const search = ref({
      start_time: "",
      end_time: "",
      order_source: "",
      day_type: 1,
      type:1
    });
    const onChangeRadio = () => {
      search.value.start_time = "";
      search.value.end_time = "";
      time.value = [];
      initData();
    };
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      search.value.day_type = 0
    };
    const detail=ref({yesterdayData:{},totalData:{}})
    const loading = ref(false);
    const initData = async () => {
      loading.value = true;
      let result = await getOrderGeneral(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      detail.value=result.data
      loading.value = false;
    };
    initData();
    return {
      dataSource,
      columns,
      onChange,
      time,
      search,
      initData,
      onChangeRadio,
      loading,
      detail
    };
  },
};
</script>
<style lang="less" scoped>
.card {
  height: 140px;
  border-radius: 8px;
  &:first-child {
    flex: 1;
  }
  &:nth-child(2) {
    flex: 2;
  }
  .card_main {
    height: 100%;
    .border-right {
      border-right: 1px solid #D0D9E3;
    }
    .card_items {
        border-radius: 5px;
      display: flex;
      flex: 1;
      align-items: center;
      height: 100%;
      .card_item {
        padding: 0 20px;
        height: 80%;
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h6 {
          font-size: 30px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 600;
          color: #333;
          line-height: 51px;
        }
        span {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #333;
          line-height: 24px;
        }
      }
    }
  }
}
</style>